export interface IPromoCodeState {
    /**
     * Set to true if the app is waiting for a response from the promo-code API.
     */
    promoCodeRequesting: boolean;
    /**
     * The promo code that is currently being entered.
     */
    promoCodeString: string;
    /**
     * The promo code that has been applied.
     */
    appliedPromoCode: string;
    /**
     * The response from the last time the promo code API was called.
     */
    promoApiResponse: any;
    /**
     * The current state of the promo code.
     */
    promoCodeState: PromoCodeState;
    /**
     * If the API responds with an error.
     */
    promoCodeError: any;
}


export enum PromoCodeState {
    APPLIED,
    FAILURE,
    ATTEMPT
}

export const defaultPromoCodeState: IPromoCodeState = {
    appliedPromoCode: "",
    promoCodeRequesting: false,
    promoCodeState: PromoCodeState.ATTEMPT,
    promoApiResponse: null,
    promoCodeError: null,
    promoCodeString: ""
};